import { useState } from 'react';

export default function RegionalLeaders() {
  const [selectedRegion, setSelectedRegion] = useState('north-america');

  const regions = [
    { id: 'north-america', name: 'North America', icon: 'ri-map-pin-line' },
    { id: 'europe', name: 'Europe', icon: 'ri-map-pin-line' },
    { id: 'asia', name: 'Asia', icon: 'ri-map-pin-line' },
    { id: 'south-america', name: 'South America', icon: 'ri-map-pin-line' },
    { id: 'oceania', name: 'Oceania', icon: 'ri-map-pin-line' }
  ];

  const regionalData: Record<string, any[]> = {
    'north-america': [
      { rank: 1, name: 'ShadowStrike', country: 'USA', flag: '🇺🇸', points: 15847 },
      { rank: 2, name: 'StyleMaster', country: 'Canada', flag: '🇨🇦', points: 13856 },
      { rank: 3, name: 'IceBreaker', country: 'USA', flag: '🇺🇸', points: 12456 }
    ],
    'europe': [
      { rank: 1, name: 'ThunderStrike', country: 'Germany', flag: '🇩🇪', points: 13492 },
      { rank: 2, name: 'NightHawk', country: 'UK', flag: '🇬🇧', points: 13178 },
      { rank: 3, name: 'VortexGaming', country: 'France', flag: '🇫🇷', points: 12934 }
    ],
    'asia': [
      { rank: 1, name: 'PhantomEdge', country: 'South Korea', flag: '🇰🇷', points: 15234 },
      { rank: 2, name: 'BladeRunner', country: 'Japan', flag: '🇯🇵', points: 14567 },
      { rank: 3, name: 'DragonFist', country: 'China', flag: '🇨🇳', points: 12789 }
    ],
    'south-america': [
      { rank: 1, name: 'RevenantKing', country: 'Brazil', flag: '🇧🇷', points: 14892 },
      { rank: 2, name: 'StormChaser', country: 'Argentina', flag: '🇦🇷', points: 11234 },
      { rank: 3, name: 'SolarFlare', country: 'Chile', flag: '🇨🇱', points: 10567 }
    ],
    'oceania': [
      { rank: 1, name: 'CrimsonFury', country: 'Australia', flag: '🇦🇺', points: 12567 },
      { rank: 2, name: 'TidalWave', country: 'New Zealand', flag: '🇳🇿', points: 10892 },
      { rank: 3, name: 'CoralReef', country: 'Australia', flag: '🇦🇺', points: 9456 }
    ]
  };

  return (
    <section className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">Regional Leaders</h2>
          <p className="text-gray-400 text-lg">Top players from each competitive region</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {regions.map(region => (
            <button
              key={region.id}
              onClick={() => setSelectedRegion(region.id)}
              className={`px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                selectedRegion === region.id
                  ? 'bg-purple-600 text-white'
                  : 'bg-gray-900 text-gray-300 hover:bg-gray-700'
              }`}
            >
              <i className={`${region.icon} mr-2`}></i>
              {region.name}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {regionalData[selectedRegion].map((player, index) => (
            <div 
              key={player.rank}
              className={`bg-gray-900 rounded-xl p-6 border-2 transition-all hover:transform hover:scale-105 cursor-pointer ${
                index === 0 ? 'border-yellow-500' :
                index === 1 ? 'border-gray-400' :
                'border-orange-600'
              }`}
            >
              <div className="text-center mb-6">
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full font-bold text-2xl mb-4 ${
                  index === 0 ? 'bg-yellow-500 text-gray-900' :
                  index === 1 ? 'bg-gray-400 text-gray-900' :
                  'bg-orange-600 text-white'
                }`}>
                  {player.rank}
                </div>
                <div className="text-4xl mb-3">{player.flag}</div>
                <h3 className="text-2xl font-bold text-white mb-2">{player.name}</h3>
                <p className="text-gray-400">{player.country}</p>
              </div>

              <div className="bg-gray-800 rounded-lg p-4 text-center">
                <div className="text-gray-400 text-sm mb-1">Total Points</div>
                <div className="text-3xl font-bold text-purple-400">
                  {player.points.toLocaleString()}
                </div>
              </div>

              <button className="w-full mt-4 bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-user-line mr-2"></i>
                View Profile
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
